<section *ngIf="locationsArray.length > 0" class="space-pb" style="padding-top:20px;background-color:#F6F6F6;">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="section-title">
            <h2 style="font-weight:heavy;">Travel deals under R5000</h2>
            <h4>Heita! So, you want to get out there and you’re looking for something great within your budget. Here are some of the hottest deals for stays and activities to suit the kind of experience you’re looking for. It’s your country, Enjoy it!</h4>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="carousel-wrapper">
            <!--Left Navigation-->
            <button class="custom-nav-button prev-button" (click)="prevSlide()">
              <i class="fas fa-solid fa-arrow-left"></i>
            </button>
            <!--Carousel-->
            <div class="carousel-container">
              <owl-carousel-o class="owl-carousel-o" #owlCarousel [options]="customOptions">
                <ng-container *ngFor="let loc of locationsArray; let i = index">
                  <ng-template carouselSlide [id]="'slide-' + i">
                    <div class="location-item-02 bg-holder text-center" [style.background-image]="'url(' + loc.cf_images[0]?.mx_image + ')'">
                      <!--<div *ngIf="loc.cf_price == loc.cf_newPrice" class="NowPrice">
                          &nbsp;&nbsp;&nbsp;&nbsp;Now {{ loc.cf_price }}&nbsp;&nbsp;&nbsp;&nbsp;
                      </div>-->
                      <div *ngIf="loc.cf_price === loc.cf_newPrice" class="NowPrice">
                          &nbsp;&nbsp;&nbsp;&nbsp;{{ loc.cf_currency }} {{ loc.cf_price }}&nbsp;&nbsp;&nbsp;&nbsp;    
                      </div>
                      <div *ngIf="loc.cf_price !== loc.cf_newPrice">
                        <div class="Specialdiscount strikethrough-text">
                            &nbsp;&nbsp;Was {{ loc.cf_currency }} {{ loc.cf_price }}&nbsp;&nbsp;&nbsp;
                        </div>
                        <div class="NowPrice">
                            &nbsp;&nbsp;Now {{ loc.cf_currency }} {{ loc.cf_newPrice }}&nbsp;&nbsp;
                        </div>
                      </div>
                      <div class="listing-image">
                        <div class="listing-quick-box">
                          <!-- Share icon moved to listing details section -->
                        </div>
                      </div>
                    </div>
                    <div class="listing-item">
                      <div class="listing-details">
                        <div class="listing-details-inner">
                          <div class="listing-title">
                            <h6><a>{{loc.title.substring(0,60)}}</a></h6> 
                          </div>
                          <div class="listing-info">
                            <div class="mb-0 multiline-truncate">{{loc.cf_deal_summary.substring(0,200)}}</div>
                          </div>
                          <br/>
                          <div>
                            <a class="listing-loaction" aria-label="Location"> 
                              <i class="fas fa-map-marker-alt"></i> 
                                {{loc.cf_destinations[0]?.mx_city}}
                            </a>
                          </div>
                          <div>
                            <app-pill> {{ loc.cf_priceCategory }}</app-pill>
                            <app-pill> {{ loc.cf_experience_desc }} </app-pill>
                            <!-- Share icon positioned to the right of pills -->
                            <a class="iconsyellow social-share" data-toggle="tooltip" data-placement="top" title="Share">
                              <i class="fas fa-share-alt"></i>
                              <div class="social-box">
                               <!-- <a target="_blank" [href]="facebook" aria-label="Share on Facebook">
                                  <i class="fab fa-facebook-f"></i>
                                </a>
                                &nbsp;
                                <a target="_blank" [href]="twitter + loc.title" aria-label="Share on X">
                                  <i class="fa-brands fa-x-twitter"></i>
                                </a>
                                &nbsp;
                                <a [href]="'mailto:?subject=South African Tourism: ' + loc.title + '&body=' + loc.cf_deal_description + ' ' + break + ' ' + email" 
                                  aria-label="Share via Email">
                                  <i class="fas fa-envelope"></i>
                                </a>
                                &nbsp;-->
                                <a target="_blank" [href]="whatsapp + 'deals/' + loc.url_title"  aria-label="Share on Whatsapp">
                                  <i class="fa-brands fa-whatsapp">&nbsp;</i>
                                </a> 
                              </div>
                            </a>
                          </div> 
                        </div>
                        <div class="listing-bottom">
                          <!--<div class="col-6 text-left listing-shotleft">
                            <span class="listing-price">{{ loc.cf_currency }} {{loc.cf_newPrice}}</span>
                          </div>-->
                          <div class="col-12 text-right listing-shotright">
                            <span class="listing-open" (click)="goToDeals(loc.url_title)">Explore more &gt;</span>
                          </div>  
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </ng-container>
              </owl-carousel-o>
            </div>
            <!--Right Navigation-->
            <button class="custom-nav-button next-button" (click)="nextSlide()">
              <i class="fas fa-solid fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>